import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import {
  CALL_AGENT_STATUS_AGGREGATE,
  FETCH_AGENT_ON_BREAK_DETAILS_SUCCESS,
  FETCH_AGENT_STATUS_SUCCESS,
  FETCH_TOTAL_AGENT_LIST_SUCCESS
} from "../actions/agentStatusActions";

const intitialState = {
  entities: null,
  agentsBreakDetails: null,
  totalAgentsList: null,
  liveAgentStatusDetails: {
    agentStatusAggregate: {},
    agentList: [],
    timerMapDuration: {},
    allQueues: [],
    totalAgents: [],
  },
};
const getKeyName = () => {
  return process.env.REACT_APP_VERSION + "-agentsStatus";
};

export const agentStatusReducer = persistReducer(
  {
    storage,
    key: getKeyName(),
    whitelist: [],
  },
  (state = intitialState, action) => {
    switch (action.type) {
      case FETCH_AGENT_STATUS_SUCCESS: {
        if (action.payload && action.payload.status === 200) {
          var newState = {
            ...state,
            entities: action.payload.success.data,
          };
        }
        return newState;
      }
      case FETCH_AGENT_ON_BREAK_DETAILS_SUCCESS: {
        if (action.payload && action.payload.status === 200) {
          var agentBreakNewState = {
            ...state,
            agentsBreakDetails: action.payload.success.data,
          };
        }
        return agentBreakNewState;
      }
      case CALL_AGENT_STATUS_AGGREGATE: {
        if (action.payload) {
          var agentStatusNewState = {
            ...state,
            liveAgentStatusDetails: {
              ...state.liveAgentStatusDetails,
              ...action.payload,
            },
          };
        }
        return agentStatusNewState;
      }
      case FETCH_TOTAL_AGENT_LIST_SUCCESS: {
        if (action.payload && action.payload) {
          var agentListNewState = {
            ...state,
            totalAgentsList: action.payload,
          };
        }
        return agentListNewState;
      }
      case actionTypes.Logout: {
        return intitialState;
      }
      default: {
        return state;
      }
    }
  }
);
